// extracted by mini-css-extract-plugin
export var externalLink = "_bt-0";
export var internalLinkLabel = "_bt-1";